import { Injectable } from '@angular/core';
import { OAuthService, AuthConfig } from 'angular-oauth2-oidc';

@Injectable({
  providedIn: 'root',
})
export class OauthService {
  private oauthInstance: OAuthService | null = null;
  private providerKey = '';   // empty until loadConfig() runs
  public events: any;

  constructor(private _oauthInstance: OAuthService) {
    this.oauthInstance = this._oauthInstance
    this.providerKey  = '';
    this.events = this._oauthInstance.events
  }

  loadConfig(oauthConfig: AuthConfig): void {
    
    this.oauthInstance?.configure(oauthConfig)
    this.oauthInstance?.setStorage(localStorage);
    this.oauthInstance?.loadDiscoveryDocumentAndTryLogin();
    this.providerKey = oauthConfig?.issuer ?? '';
  }

  getOAuthInstance(): OAuthService {
    if (this.oauthInstance === null) {
      throw new Error('OAuth is not initialized');
    } else {
      return this.oauthInstance;
    }
  }

  getType(): string { return this.providerKey; }

  initCodeFlow() {
    return this.oauthInstance?.initCodeFlow()
  }

  getAccessToken() {
    return this.oauthInstance?.getAccessToken()
  }
}
